const { MODE } = import.meta.env;

const rawBasePath = import.meta.env.VITE_SERVER_BASE_PATH ?? '/app/';

const ensureLeadingSlash = (path: string) => {
  if (!path.startsWith('/')) {
    return `/${path}`;
  }
  return path;
};

const ensureTrailingSlash = (path: string) => {
  if (!path.endsWith('/')) {
    return `${path}/`;
  }
  return path;
};

export const BASE_PATH = ensureTrailingSlash(ensureLeadingSlash(rawBasePath));

export const isDev = () => {
  return MODE === 'development' || MODE === 'dev' || MODE === 'prestage';
};

export const isStaging = () => {
  return MODE === 'staging';
};

export const isDevOrStaging = () => {
  return isStaging() || isDev();
};

export const isBeta = () => {
  return MODE === 'beta';
};

export const isProduction = () => MODE === 'production';
export const isNonProduction = () => isDevOrStaging() || isBeta();
